import React, { Component, Fragment } from 'react';
import NanoBar from '../../components/base/NanoBar';
import { nanoProgressSetup } from '../../lib/progress';
import FullscreenLoaderContainer from './FullscreenLoaderContainer';

class Core extends Component {
  componentDidMount() {
    /**
     *  서버요청에 대한 progress 진척도를 보여주기 위한 setup
     */
    nanoProgressSetup();
  }

  render() {
    return (
      <Fragment>
        <FullscreenLoaderContainer />
        <NanoBar />
      </Fragment>
    );
  }
}

export default Core;
